import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="notification"
export default class extends Controller {

  static values = { timeout: { type: Number, default: 4500 } }
  
  static classes = ["active"]
  
  connect() {
    this.element.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.element.style.opacity = "1"
      this.element.style.transform = "translateY(0)"
    })
    if (this.timeoutValue > 0) this.timer = setTimeout(this.close.bind(this), this.timeoutValue)
  }

  close() {
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-0.5rem)"
    this.element.addEventListener("transitionend", () => this.element.remove(), { once: true })
    setTimeout(() => this.element?.remove(), 300)
  }
  
  disconnect() {
    this.timer && clearTimeout(this.timer)
  }
  
}
